import { MainController } from "../controller/mainController";
import { IntroScene } from "../display/introScene";
import { Text } from "../display/text";

class Chapter4Intro extends IntroScene {



	constructor() {
		super("chapter4Intro");
        this.chapter = "chapter4";
		this.title = Text.get('chapter4-intro-title');
		this.subtitle = Text.get('chapter4-intro-subtitle');


        MainController.registerChapter(this);
    } 


    create ()
    {
        super.create();

        // j'enregistre la scène intro en bookmark
        MainController.bookmarkChapter(this);
        MainController.setCurrentScene( this );
        
		this.goToScene("chapter4Scene1", 5000);

    }


    beforeTransition()
    {
        //'on kill tout ce qui peut se déclencher pendant la transition'
        console.log('beforeTransition '+this.name);
    }

    beforeDestroy()
    {
        //'on peut tout killer'
        
    }

}
export {Chapter4Intro}